module.exports = __webpack_public_path__ + "static/media/location.acf36599.svg";